export default __webpack_public_path__ + "static/media/dog4.e7d640d8.JPG";